import React from 'react';
import PropTypes from 'prop-types';
import PopupCloseButtonMobile from "./PopupCloseButtonMobile";

const popupWidth = 340;
const legendWidth = window.innerWidth >= 500 ? 320 : 0;

const MapPopup = ({ coords, onClose, children, centerWidth, isMobile }) => {
	let offsetLeft = coords.x + (centerWidth ? centerWidth / 2 : 0);

	const markerOffsetLeft = offsetLeft - legendWidth - 10;
	if (markerOffsetLeft <= 20)
		return null;

	// const markerOffsetRight = offsetLeft + 16;
	let needToMoveMarkerToLeft = false;
	let needToMoveMarkerToRight = false;

	if (!isMobile && coords.x >= 20 && offsetLeft < popupWidth / 2 + 10 + legendWidth) {
		needToMoveMarkerToLeft = true;
		offsetLeft += popupWidth / 2 - offsetLeft + 10 + legendWidth;
	}

	const offsetTop = coords.y + ((centerWidth && centerWidth <= 25) ? centerWidth / 2 : 0) - 20;
	const translateLeft = `calc(-50% + ${offsetLeft}px)`;

	return (
		<div
			className="track-popup"
			style={{
				maxWidth: popupWidth,
				transform: `translate(${translateLeft}, calc(-100% + ${offsetTop}px))`
			}}
		>
			{isMobile ? <PopupCloseButtonMobile onClick={onClose}/> :
				<button onClick={onClose} className="track-popup__close-button"/>}

			<div className="track-popup__content">
				{children}

				<span
					className="marker"
					style={needToMoveMarkerToLeft || needToMoveMarkerToRight ? {
						left: (markerOffsetLeft <= 20) ? 20 : markerOffsetLeft
					} : null}
				/>
			</div>
		</div>
	)
};

MapPopup.defaultProps = {
	coords: { x: 0, y: 0 }
};

MapPopup.propTypes = {
	coords: PropTypes.object,
	text: PropTypes.any,
	width: PropTypes.number,
	height: PropTypes.number,
	centerWidth: PropTypes.number,
	isMobile: PropTypes.bool
};

export default MapPopup;
